import { render, staticRenderFns } from "./selectProductDetail.vue?vue&type=template&id=83b25fd0&scoped=true"
import script from "./selectProductDetail.vue?vue&type=script&lang=js"
export * from "./selectProductDetail.vue?vue&type=script&lang=js"
import style0 from "./selectProductDetail.vue?vue&type=style&index=0&id=83b25fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b25fd0",
  null
  
)

export default component.exports